export default function validateSelect(field) {
  if (!field.length) {
    return 'select an alternative';
  }
}
